module.exports = __webpack_public_path__ + "static/media/research-9.6b417580.svg";